module.exports = __webpack_public_path__ + "img/goToQuests.fa8e27c4.gif";